import React from 'react';

const Divider = () => {
  return (
    <div className="w-full border-t border-gray-400 my-4"/>
  )
};

export default Divider;